import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideRouter, UrlSerializer, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { NoTrailingSlashUrlSerializer } from './shared/serializers/trailing-slash.serializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        // anchorScrolling: 'enabled',   
      }),
    ),
    provideClientHydration(withEventReplay()),
    { provide: UrlSerializer, useClass: NoTrailingSlashUrlSerializer }
  ],
};


